import * as Sentry from "@sentry/gatsby"

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,
  environment: process.env.GATSBY_ENVIRONMENT,
  release: process.env.GATSBY_SENTRY_RELEASE,
  sendDefaultPii: true,
  ignoreErrors: [
    // Hyros UTS network failures on iOS/Mobile Safari — these are unactionable
    // third-party errors from the tracking script itself
    /XMLHttpRequest Error: Network request failed/,
    /Non-Error promise rejection captured with value: XMLHttpRequest Error/,
    /^Non-Error promise rejection captured with value: undefined$/,
  ],
  denyUrls: [
    // Suppress errors originating from Hyros tracking scripts
    /214923\.t\.hyros\.com/,
    /lg\.hyr\.so/,
  ],
})
